import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import Moment from 'moment';

export const baseURI = '/empresas/categorias-de-giros-de-licencias/';

/**
 * GET CategoriasDeGiro
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getCategoriasDeGiro = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET CategoriaDeGiro
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getCategoriaDeGiro = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST CategoriaDeGiro
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCategoriaDeGiro = async (values) => {
  try {
    const valuesEntidad = values;
    valuesEntidad.entidad = 1;
    const response = await API.post(baseURI, valuesEntidad);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH CategoriaDeGiro
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchCategoriaDeGiro = async (id, _values) => {
  try {
    const values = {
      ..._values,
      fecha_de_ultimo_movimiento: Moment(),
    };
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE CategoriaDeGiro
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteCategoriaDeGiro = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
